/**
 * NEMA fee schedule (Developer Technical Brief v2.0) — frontend mirror of server constants.
 * Server `/api/billing/fee-schedule` is authoritative for production.
 */
export const INVOICE_DESCRIPTION = "Digital Marketplace Facilitation Services";

export const GST_RATE = 0.18;

export const FULL_TIME = {
  SECURITY_DEPOSIT: 3000,
  POLICE_VERIFICATION: 500,
  CUSTOMER_PLATFORM_FEE_MONTHLY: 0,
  CUSTOMER_SUBSCRIPTION_MONTHLY: 1000,
  CUSTOMER_COMMITMENT_FEE: 500,
  CAREGIVER_ACTIVATION_FEE: 1000,
  POST_TRIAL_DEPOSIT_RETAINED: 1000,
};

export const CARE_MANAGER = {
  SUBSCRIPTION_MONTHLY: 1000,
  MANAGEMENT_FEE_MONTHLY: 2000,
  NEMA_SHARE_OF_MANAGEMENT: 600,
  CARE_MANAGER_SHARE_OF_MANAGEMENT: 1400,
};

export const REACTIVATION = {
  CUSTOMER: 2000,
  CUSTOMER_SIX_MONTH_MEMBERSHIP: 3000,
  CAREGIVER: 1000,
};

export const HOURLY = {
  CAREGIVER_RATE_PER_HOUR: 120,
  PLATFORM_FLAT: 0,
  PLATFORM_PCT_OF_CAREGIVER_EARNINGS: 0,
  TRAVEL_PER_KM: 8,
  TRAVEL_MIN: 40,
  TRAVEL_MAX: 120,
  POLICE_VERIFICATION_FIRST_ENGAGEMENT: 500,
  POLICE_NEMA_COST: 250,
  POLICE_NEMA_MARGIN: 250,
};

export const INTRO_CALLS = {
  FREE_CALLS: 3,
  FREE_MINUTES_EACH: 5,
};

/** Legacy fee constants — Care Pass plans gate contact/hire; FREE_* unused for gating. */
export const MARKETPLACE_ACCESS = {
  PLAN_AMOUNT_INR: 3000,
  VALIDITY_DAYS: 90,
  FREE_PROFILE_VIEWS: 10,
  FREE_CALLS: 3,
  FREE_CALL_MINUTES: 5,
};

/** CareHub guest checkout — platform booking fee (disabled for customers). */
export const PLATFORM_BOOKING_FEE = {
  AMOUNT_INR: 0,
  LINE_CODE: "PLATFORM_BOOKING_FEE",
};

export const PAYMENT_AMOUNTS = {
  SUBSCRIPTION: FULL_TIME.CUSTOMER_SUBSCRIPTION_MONTHLY,
  MARKETPLACE_ACCESS: MARKETPLACE_ACCESS.PLAN_AMOUNT_INR,
  PLATFORM_FEE: FULL_TIME.CUSTOMER_PLATFORM_FEE_MONTHLY,
  DEPOSIT: FULL_TIME.SECURITY_DEPOSIT,
  COMMITMENT_FEE: FULL_TIME.CUSTOMER_COMMITMENT_FEE,
  ACTIVATION_FEE: FULL_TIME.CAREGIVER_ACTIVATION_FEE,
  POLICE_VERIFICATION: FULL_TIME.POLICE_VERIFICATION,
  CARE_MANAGER_FEE: CARE_MANAGER.MANAGEMENT_FEE_MONTHLY,
  REACTIVATION_FEE: REACTIVATION.CUSTOMER,
  CAREGIVER_REACTIVATION_FEE: REACTIVATION.CAREGIVER,
};
